import * as $ from 'jquery';
import 'bootstrap';
import * as Slideout from 'slideout';

export class enrichMenu {
	$scope: any = $('#menuenrich-header');
	$navbarToggle: any = $('#menuenrich-header .navbar-toggle');
	$memberContents: any = $('#enrich-content');

	// Initialize mobile slider navigation
	// slideNav(): void {
	// 	let _self = this;
	// 	var slideout: any = new Slideout({
	// 		'panel': document.getElementById('enrich-content'),
	// 		'menu': $('.mabe-nav--overlay')[0],
	// 		'padding': '0px',
	// 		'tolerance': 70,
	// 		'side': 'left',
	// 		'ease': 'cubic-bezier(.32,2,.55,.27)',
	// 		'transition-delay': '5s'
	// 	});
	// 	var slideoutSide: any = new Slideout({
	// 		'panel': document.getElementById('enrich-content'),
	// 		'menu': $('.mabe-nav--overlay')[0],
	// 		'padding': '310px',
	// 		'tolerance': 70,
	// 		'side': 'right',	
	// 		'easing': 'cubic-bezier(.32,2,.55,.27)'
	// 	});

	// 	_self.$scope.find('.navbar-toggle').on('click', () => {
	// 		if (window.innerWidth < 768) {
	// 			slideout.toggle();
	// 		} else {
	// 			slideoutSide.toggle();
	// 		}
	// 	});

	// 	let top: number = 0;
	// 	let $body: any = $('body');
	// 	slideout.on('open', () => {
	// 		top = $(window).scrollTop();
	// 		$body.css({
	// 			'position': 'fixed',
	// 			'top': -top
	// 		});
	// 	});
	// 	slideoutSide.on('open', () => {
	// 		top = $(window).scrollTop();
	// 		$body.css({
	// 			'position': 'fixed',
	// 			'top': -top
	// 		});
	// 	});

	// 	slideout.on('close', () => {
	// 		$body.css({
	// 			'position': '',
	// 			'top': ''
	// 		});
	// 		$body.scrollTop(top);
	// 	});
	// 	slideoutSide.on('close', () => {
	// 		$body.css({
	// 			'position': '',
	// 			'top': ''
	// 		});
	// 		$body.scrollTop(top);
	// 	});

	// 	// when slideout is open, on click main content area, close menu
	// 	slideout
	// 		.on('open', function () {
	// 			_self.$memberContents.addClass('slideout-open');
	// 			_self.$memberContents.on('click', function (e: any) {
	// 				slideout.close();
	// 			});
	// 		})
	// 		.on('close', function () {
	// 			_self.$memberContents.removeClass('slideout-open');
	// 			_self.$memberContents.unbind('click');
	// 		});
	// 	slideoutSide
	// 		.on('open', function () {
	// 			_self.$memberContents.addClass('slideout-open');
	// 			_self.$memberContents.on('click', function (e: any) {
	// 				slideoutSide.close();
	// 			});
	// 		})
	// 		.on('close', function () {
	// 			_self.$memberContents.removeClass('slideout-open');
	// 			_self.$memberContents.unbind('click');
	// 		});

	// 	$('.slideOutClose').click(function () {
	// 		if (window.innerWidth < 768) {
	// 			slideout.close();
	// 		} else {
	// 			slideoutSide.close();
	// 		}
	// 	});
	// }
}

let scope: Element = document.querySelector('#enrich-content');
if (scope) {
	try {
		let memberheader = new enrichMenu();
		$(".mabe-nav--overlay").css({ 'top': '100%' });
		$(".mabe-nav--overlay").css({ 'opacity': '0' });
		$(".mabe-nav--overlay").css({ 'margin-top': '-666px' });
		$(".mabe-nav--overlay").css({ 'pointer-events': 'none' });
		// $(".mabe-nav--overlay").show();
		$('.member-nav__toggle-btn').click(function () 
		{
		 $(".mabe-nav--overlay").css({ 'margin-top': '0px' });	
		 $(".mabe-nav--overlay").css({ 'top': '0' });
		 $(".mabe-nav--overlay").css({ 'opacity': '1' });
		 $(".mabe-nav--overlay").css({ 'height': '100%' });
		 $(".mabe-nav--overlay").css({ 'pointer-events': 'auto' });
		 $(".mabe-nav--overlay").css({'transition': 'all .3s ease-out'});
		//   $(disableallothers).css({ 'top': '0' });
	});
	$('.slide_close').click(function () 
		{
		  $(".mabe-nav--overlay").css({ 'top': '100%' });
		  $(".mabe-nav--overlay").css({ 'height': '0px' });
		  $(".mabe-nav--overlay").css({ 'margin-top': '-666px' });		
		  $(".mabe-nav--overlay").css({'transition': 'all .3s ease-out'});	  
		  $(".mabe-nav--overlay").css({ 'opacity': '0' })
		  $(".mabe-nav--overlay").css({ 'pointer-events': 'none' });
						
	});


		// $(document).ready(function () {
		// 	if ($('#enrich-content').length > 0) {
		// 		memberheader.slideNav();
		// 		//$('body').addClass('mhZeroRightPad');
		// 		//$('.sidebar-menu-link').addClass('collapsed');
		// 	}
			
			$('.sidebar-menu-link').on('click', function () {
				if ($(this).attr("role") === "button") {
					if ($(this).parent().parent().hasClass('sidebar-menu--level-2')) {
						$(this).parent().parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-2').not($(this).parent().parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-3').collapse('hide');
					}else if($(this).parent().parent().hasClass('sidebar-menu--level-3')){
						$(this).parent().parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-3').not($(this).parent().parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-4').collapse('hide');
					}
					else {
						$('ul .members__menu.sidebar-menu--level-2').collapse('hide');
						$('ul .members__menu.sidebar-menu--level-3').collapse('hide');
						$('ul .members__menu.sidebar-menu--level-4').collapse('hide');
					}
				}
			});

			$('nav.members-nav.navbar li').each(function () {
				if ($(this).hasClass('active')) {
					if ($(this).parent().hasClass('sidebar-menu--level-3')) {
						$(this).parent().parent().parent().collapse('show');
						$(this).parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-3').not($(this).parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-2').not($(this).parent().parent().parent()).collapse('hide');
					} else if ($(this).parent().hasClass('sidebar-menu--level-4')) {
						$(this).parent().parent().parent().parent().parent().collapse('show');
						$(this).parent().parent().parent().collapse('show');
						$(this).parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-4').not($(this).parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-3').not($(this).parent().parent().parent()).collapse('hide');
						$('ul .members__menu.sidebar-menu--level-2').not($(this).parent().parent().parent().parent().parent()).collapse('hide');
					}else {
						$(this).parent().collapse('show');
						$('ul .members__menu.sidebar-menu--level-4').collapse('hide');
						$('ul .members__menu.sidebar-menu--level-3').collapse('hide');
						$('ul .members__menu.sidebar-menu--level-2').not($(this).parent()).collapse('hide');
					}
				}
			});
	} catch (e) { console.error(e); }
}